import React, { useState, useEffect } from 'react';

const CpcTrafficClientsForm = ({ record, onSave, onClose, currentUser }) => {
  const [formData, setFormData] = useState({
    mes: '',
    seguimiento: '',
    fecha_asunto: '',
    nombre_cliente: '',
    cuenta_publicitaria: '',
    celula: '',
    campana: '',
    asunto: 'Cliente presenta aumento significativo en CPC y disminución notable en el tráfico',
    acciones: '',
    status: 'pendiente'
  });
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [clients, setClients] = useState([]);
  const [clientSearchTerm, setClientSearchTerm] = useState('');
  const [filteredClients, setFilteredClients] = useState([]);
  const [showClientDropdown, setShowClientDropdown] = useState(false);

  const meses = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];

  const celulas = [
    'C1GA', 'C2GA', 'C3GA', 'C4GA', 'C5GA', 'C6GA', 'C7GA',
    'C1MA', 'C2MA', 'C3MA', 'C4MA',
    'G1M1', 'G1M2', 'G1M3', 'G1M4',
    'G2M1', 'G2M2', 'G2M3', 'G2M4',
    'G3M1', 'G3M2', 'G3M3', 'G3M4',
    'G4M1', 'G4M2', 'G4M3', 'G4M4',
    'G5M1', 'G5M2', 'G5M3', 'G5M4',
    'G6M1', 'G6M2', 'G6M3', 'G6M4',
    'G7M1', 'G7M2', 'G7M3', 'G7M4'
  ];

  useEffect(() => {
    if (record) {
      setFormData({
        mes: record.mes || '',
        seguimiento: record.seguimiento || '',
        fecha_asunto: record.fecha_asunto ? new Date(record.fecha_asunto).toISOString().split('T')[0] : '',
        nombre_cliente: record.nombre_cliente || '',
        cuenta_publicitaria: record.cuenta_publicitaria || '',
        celula: record.celula || '',
        campana: record.campana || '',
        asunto: record.asunto || 'Cliente presenta aumento significativo en CPC y disminución notable en el tráfico',
        acciones: record.acciones || '',
        status: record.status || 'pendiente'
      });
      setClientSearchTerm(record.nombre_cliente || '');
    }
    
    loadUsers();
    loadClients();
  }, [record]);

  // Cargar usuarios del sistema
  const loadUsers = async () => {
    try {
      const API_URL = process.env.NODE_ENV === 'production' 
        ? process.env.REACT_APP_API_URL || 'https://dashboard.doctorweb.top/api'
        : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api');

      const response = await fetch(`${API_URL}/users`);
      if (response.ok) {
        const data = await response.json();
        setUsers(data);
      }
    } catch (error) {
      console.error('Error al cargar usuarios:', error);
    }
  };

  // Cargar clientes del sistema
  const loadClients = async () => {
    try {
      const API_URL = process.env.NODE_ENV === 'production' 
        ? process.env.REACT_APP_API_URL || 'https://dashboard.doctorweb.top/api'
        : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api');

      const response = await fetch(`${API_URL}/clients`);
      if (response.ok) {
        const data = await response.json();
        setClients(data);
      }
    } catch (error) {
      console.error('Error al cargar clientes:', error);
    }
  };

  // Filtrar clientes en tiempo real
  useEffect(() => {
    if (clientSearchTerm.length > 0) {
      const filtered = clients.filter(client =>
        client.name?.toLowerCase().includes(clientSearchTerm.toLowerCase()) ||
        client.email?.toLowerCase().includes(clientSearchTerm.toLowerCase()) ||
        client.company?.toLowerCase().includes(clientSearchTerm.toLowerCase())
      );
      setFilteredClients(filtered.slice(0, 10)); // Limitar a 10 resultados
      setShowClientDropdown(filtered.length > 0);
    } else {
      setFilteredClients([]);
      setShowClientDropdown(false);
    }
  }, [clientSearchTerm, clients]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleClientSearch = (e) => {
    const value = e.target.value;
    setClientSearchTerm(value);
    setFormData(prev => ({
      ...prev,
      nombre_cliente: value
    }));
  };

  const handleClientSelect = (client) => {
    const clientName = client.name || client.email || 'Cliente';
    setClientSearchTerm(clientName);
    setFormData(prev => ({
      ...prev,
      nombre_cliente: clientName,
      celula: client.cell || prev.celula // Si el cliente tiene célula asignada, usarla
    }));
    setShowClientDropdown(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.mes || !formData.seguimiento || !formData.fecha_asunto || !formData.nombre_cliente) {
      alert('Por favor, completa todos los campos obligatorios.');
      return;
    }

    setLoading(true);
    try {
      await onSave(formData);
    } catch (error) {
      console.error('Error al guardar:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-bold text-gray-900">
              {record ? 'Editar Registro' : 'Nuevo Registro'} - Aumento CPC y ↓ Tráfico
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Mes */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Mes *
              </label>
              <select
                name="mes"
                value={formData.mes}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              >
                <option value="">Seleccionar mes</option>
                {meses.map(mes => (
                  <option key={mes} value={mes}>{mes}</option>
                ))}
              </select>
            </div>

            {/* Seguimiento - Usuarios del sistema */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Seguimiento *
              </label>
              <select
                name="seguimiento"
                value={formData.seguimiento}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              >
                <option value="">Seleccionar usuario</option>
                {users.map(user => (
                  <option key={user.email} value={`${user.firstName} ${user.lastName} (${user.email})`}>
                    {user.firstName} {user.lastName} ({user.email})
                  </option>
                ))}
              </select>
            </div>

            {/* Fecha del Asunto */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Fecha del Asunto *
              </label>
              <input
                type="date"
                name="fecha_asunto"
                value={formData.fecha_asunto}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              />
            </div>

            {/* Nombre del Cliente - Búsqueda en tiempo real */}
            <div className="relative">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nombre del Cliente *
              </label>
              <input
                type="text"
                value={clientSearchTerm}
                onChange={handleClientSearch}
                onFocus={() => clientSearchTerm.length > 0 && setShowClientDropdown(true)}
                placeholder="Buscar cliente..."
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              />
              
              {/* Dropdown de clientes */}
              {showClientDropdown && (
                <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                  {filteredClients.map((client, index) => (
                    <button
                      key={index}
                      type="button"
                      onClick={() => handleClientSelect(client)}
                      className="w-full px-4 py-2 text-left hover:bg-gray-50 focus:bg-gray-50 focus:outline-none"
                    >
                      <div className="font-medium text-gray-900">
                        {client.name || client.email}
                      </div>
                      {client.company && (
                        <div className="text-sm text-gray-500">{client.company}</div>
                      )}
                      {client.cell && (
                        <div className="text-xs text-gray-400">Célula: {client.cell}</div>
                      )}
                    </button>
                  ))}
                  
                  {filteredClients.length === 0 && clientSearchTerm.length > 0 && (
                    <div className="px-4 py-2 text-gray-500 text-sm">
                      No se encontraron clientes. Puedes escribir el nombre manualmente.
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Cuenta Publicitaria - Link */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Cuenta Publicitaria (Link)
              </label>
              <input
                type="url"
                name="cuenta_publicitaria"
                value={formData.cuenta_publicitaria}
                onChange={handleChange}
                placeholder="https://ads.google.com/..."
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              />
            </div>

            {/* Célula */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Célula
              </label>
              <select
                name="celula"
                value={formData.celula}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              >
                <option value="">Seleccionar célula</option>
                {celulas.map(celula => (
                  <option key={celula} value={celula}>{celula}</option>
                ))}
              </select>
            </div>

            {/* Campaña */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Campaña
              </label>
              <input
                type="text"
                name="campana"
                value={formData.campana}
                onChange={handleChange}
                placeholder="Nombre de la campaña"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              />
            </div>

            {/* Status */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Estado
              </label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              >
                <option value="pendiente">Pendiente</option>
                <option value="en_proceso">En Proceso</option>
                <option value="completado">Completado</option>
                <option value="cancelado">Cancelado</option>
              </select>
            </div>
          </div>

          {/* Asunto */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Asunto
            </label>
            <textarea
              name="asunto"
              value={formData.asunto}
              onChange={handleChange}
              rows="3"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
            />
          </div>

          {/* Acciones */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Acciones Tomadas
            </label>
            <textarea
              name="acciones"
              value={formData.acciones}
              onChange={handleChange}
              rows="4"
              placeholder="Describe las acciones tomadas para resolver el problema..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
            />
          </div>

          {/* Botones */}
          <div className="flex justify-end space-x-4 pt-6 border-t border-gray-200">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-6 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
            >
              {loading && (
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              )}
              {loading ? 'Guardando...' : (record ? 'Actualizar' : 'Crear Registro')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CpcTrafficClientsForm;
